import { useEffect, type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { isAdminRole } from "@/lib/roles";
import { notifyAccessDenied } from "@/lib/accessDenied";

interface AdminRouteGuardProps {
  children: ReactNode;
}

/**
 * Chặn truy cập trực tiếp bằng đường dẫn.
 *
 * Nhân viên gõ tay /nhap-kho, /kiem-ke, /kiem-ke/lich-su, /vat-tu/kiem-ke hay
 * /luu-tru-video sẽ bị đưa về trang Quét hàng kèm thông báo không có quyền.
 *
 * Phải chờ hồ sơ nhân viên tải xong mới xét quyền, nếu không thì admin vừa F5
 * trang sẽ bị đá về nhầm (lúc đó chưa biết chức vụ của họ).
 */
export default function AdminRouteGuard({ children }: AdminRouteGuardProps) {
  const { nhanVien, loading, profileLoading } = useAuth();
  // Chỉ chờ ở lần tải đầu tiên (khi chưa biết chức vụ). Nếu hồ sơ đã có thì
  // không chặn trang nữa, tránh việc trang bị ẩn rồi dựng lại vô cớ.
  const pending = loading || (profileLoading && !nhanVien);
  const denied = !pending && !isAdminRole(nhanVien?.chuc_vu);

  useEffect(() => {
    if (denied) notifyAccessDenied();
  }, [denied]);

  if (pending) return null;
  if (denied) return <Navigate to="/scan" replace />;

  return <>{children}</>;
}